import React, { useCallback } from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import { safeHTML } from '../../../utils/safeHTML';
import { useModal } from '../../../hooks/useModal';
import { buyModalContent } from '../../../constants/copyright';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import { useTranslation } from '../../../translations';
import { useLanguageControls } from '../../../hooks/useLanguageControls';

const {
  hp: { text: hpText },
} = buyModalContent;

const BuyModal = React.forwardRef(function BuyModal(
  { itemData, title, subTitle, buttons, fromLootBox, callbacks, lootBoxesCount },
  ref,
) {
  const { id, closeModal } = useModal();
  const { t } = useTranslation();
  const { isArabic } = useLanguageControls();
  const { image, xp, priceData: { moneyCost, giftCost, beautiesCost } = {} } = itemData ?? {};
  const close = useCallback(() => closeModal({ id }), []);

  const buyModalCallbacks = {
    buy: () => {
      callbacks?.buy?.();
      close();
    },
    cancel: () => {
      close();
    },
  };

  return (
    <CustomModal animation={['fade', 'scale', 'scale-bounce']}>
      <div className={'buy-modal'} ref={ref}>
        <div className={'buy-modal__bg'} onClick={close} />
        <div className={'buy-modal__content'}>
          {image && (
            <div className={'buy-modal__image'}>
              <img src={image} alt={'img'} />
            </div>
          )}

          {title && <h2 className={'buy-modal__title'}>{safeHTML(t(title))}</h2>}

          {!!xp && (
            <div className={'buy-modal__hp'}>
              <div className={'buy-modal__hp-title'}>{safeHTML(isArabic ? `+XP${xp}` : `+${xp}XP`)}</div>
              <div className={'buy-modal__hp-text'}>{safeHTML(t(hpText))}</div>
            </div>
          )}

          {subTitle && <p className={'buy-modal__text'}>{safeHTML(t(subTitle))}</p>}

          <div className={'buy-modal__buttons'}>
            {buttons?.map?.((button, index) => {
              return (
                <CustomButton
                  key={`b-${index}`}
                  {...button?.attr}
                  disposable={true}
                  {...{
                    buy: () => {
                      if (typeof moneyCost === 'number') return { coins: true, count: moneyCost };
                      if (typeof giftCost === 'number') return { gifts: true, count: giftCost };
                      if (typeof beautiesCost === 'number') return { beauties: true, count: beautiesCost };
                    },
                  }[button.action]?.()}
                  onClick={buyModalCallbacks[button.action]}
                />
              );
            })}
          </div>
        </div>
      </div>
    </CustomModal>
  );
});
export default BuyModal;
BuyModal.propTypes = {};
